import * as actionTypes from '../actions/actionTypes';

export default function currentProductAccountReducer(state = [], action) {
  switch(action.type){
    case actionTypes.SET_PERSONS: {
      return action.persons;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/personsReducer.js